/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useHeaderStates } from "../../Providers/HeaderStates";
import { useStartupState } from "../../Providers/StartupState";
import { atualizarLayout, layoutGuardado } from "../../Api/layout";
import logoCopasulDefault from "../../assets/Logo_copasul.svg";
import { MenuDesktop } from "./MenuDesktop";
import { MenuMobile } from "./MenuMobile";
import * as S from "./style";

const logoDe = (header) =>
  header?.logoVerde?.[0] ? header.logoVerde[0].toString() : logoCopasulDefault;

export const Header = () => {
  const [optionsMenu, setOptionsMenu] = useState([]);
  // Nasce com a última versão vista (ou a embutida) e se atualiza com o
  // Squidex: o cabeçalho aparece junto com a tela de carregamento.
  const [data, setData] = useState(() => layoutGuardado("header"));
  const [logoCopasul, setLogoCopasul] = useState(() => logoDe(layoutGuardado("header")));

  const { token } = useStartupState();
  const { bgHeader, menu, setMenu } = useHeaderStates();

  useEffect(() => {
    let optionsArray = [];

    menu.map((item) => {
      item?.menu?.rota
        ? optionsArray.push({
            title: item?.menu?.tituloMenu,
            route: item?.menu?.rota,
          })
        : item?.menu?.subMenu?.map((subItem) => {
            optionsArray.push({
              title: subItem?.tituloSubmenu,
              route: subItem?.rotaSubmenu,
            });
          });
    });

    setOptionsMenu(optionsArray);
  }, [menu]);

  // O fetch vive aqui (e não em cada menu) porque os dois menus são
  // renderizados ao mesmo tempo e alternados por CSS — mantê-lo nos filhos
  // duplicaria a chamada ao Squidex a cada navegação. Não mexe no
  // "carregando" das páginas (ver Providers/HeaderStates).
  useEffect(() => {
    if (!token) return;
    atualizarLayout(token, "header")
      .then((header) => {
        setData(header);
        setLogoCopasul(logoDe(header));
      })
      .catch((e) => console.log("cabeçalho:", e.message));
  }, [token]);

  const menuProps = {
    bgHeader,
    menu,
    setMenu,
    optionsMenu,
    data,
    logoCopasul,
  };

  return (
    <>
      <S.MobileOnly>
        <MenuMobile {...menuProps} />
      </S.MobileOnly>
      <S.DesktopOnly>
        <MenuDesktop {...menuProps} />
      </S.DesktopOnly>
    </>
  );
};
